import React from "react";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import CustomButton from "components/CustomButton";

export default ({
  children,
  modelOpen,
  closeDialog,
  modalContainer = "modalContainer",
  modalClass = "modalClass",
  modalHeaderClass = "modalHeader",
  headerStyle = null,
  headerChildren,
}) => {
  return (
    <Modal
      open={modelOpen}
      onClose={closeDialog}
      showCloseIcon={false}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      classNames={{
        modalContainer: modalContainer,
        modal: modalClass,
      }}
    >
      <div className={modalHeaderClass} style={headerStyle}>
        {headerChildren}
        <CustomButton type="button" buttonClass="btn-close">
          <CloseIcon onClick={closeDialog} />
        </CustomButton>
      </div>
      {children}
    </Modal>
  );
};
